export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const ACCOUNT = '/account';
export const ACCOUNT_CHANGE_PASSWORD = '/account/change-password';
export const PASSWORD_FORGET = '/forget-password';
export const NONPROFIT = '/nonprofit';
export const NONPROFIT_REQUESTED = '/nonprofit/requested';
export const USER = '/user';
